<template>
  <div :class="['icon-attribute-item-fi', `icon-attribute-item-fi--size-${size}x`]">
    <icon-fi
      class="icon-attribute-item-fi__icon"
      :icon="icon"
      :size="`${size}`"
    />

    <div class="icon-attribute-item-fi__data">
      <span class="icon-attribute-item-fi__label">
        {{ label }}
      </span>
      <span class="icon-attribute-item-fi__value">
        {{ value }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconFi from '@/components/atoms/icon-fi/IconFi.vue';

defineOptions({
  name: 'IconAttributeItemFi',
});

interface Props {
  icon: string;
  label?: string | null;
  value?: string | null;
  size?: number;
}

withDefaults(defineProps<Props>(), {
  size: 2,
  label: '',
  value: '',
});
</script>

<style scoped src="./icon-attribute-item-fi" />
